import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DetalheBaseController } from '../../../helpers';
import { EnderecoService } from '../../../services';

@Component({
    templateUrl: 'endereco.edit.component.html',
})

export class EnderecoEditComponent extends DetalheBaseController {
   
    isReadOnly: boolean = false;
    isLoaded: boolean = false;
    id: any;
   
    constructor(route: ActivatedRoute, private _enderecoService: EnderecoService) {
        super(route, _enderecoService);                        
    }

    ngOnInit() {        
        this.id = this._route.snapshot.params['id'];
        if (this.type == "add" && this.id != 0) {                        
            let id = this._route.snapshot.params['id'] || this.id;
            this.subGet = this.service.get(this.service._api, id).subscribe(result => {                
                this.model = result;
                this.isReadOnly = true;
                this.isLoaded = true;
                this.showForm = true;                
                this.modelLoaded.emit({});
            });
        }
        else {
            this.showForm = true;
        }
    }

    public salvar(form) {        
        let type = this._route.snapshot.data['type'];        
        if (type == "edit") {            
            form.id = this.model.id;            
            this.subPut = this.service.putId(this.service._api, this.model.id, form).subscribe(result => {
                localStorage.setItem('msgSucesso', this.translate.instant("controllerBase.registroSalvoComSucesso") + '!');
                this._location.back();
            });
        } else {
            this.subPost = this.service.post(this.service._api, form).subscribe(result => {
                localStorage.setItem('msgSucesso', this.translate.instant("controllerBase.registroSalvoComSucesso") + '!');
                this._location.back();
            });
        }
    }

    buscarEndereco() { 
        if (this.model.cep.length == 8) {
            if (this.isLoaded == true) {
                this.isLoaded = false;
                return;
            }
            this.carregarLoading();
            this._enderecoService.getByCep(this.model.cep).subscribe(result => {
                this.isReadOnly = true;
                this.model.logradouro = result.Logradouro;
                this.model.bairro = result.Bairro;
                this.model.complemento = result.Complemento;
                this.model.uf = result.Estado;
                this.model.cidade = result.Cidade;                
                this.fecharLoading();
            });
        }
        else
            this.isReadOnly = false;            
    }    
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/endereco/edit/endereco.edit.component.ts